import _regeneratorRuntime from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent, createTextVNode as _createTextVNode2, resolveComponent as _resolveComponent2, createVNode as _createVNode2 } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef } from "vue";
var _hoisted_1 = {
  class: "profile"
};
var _hoisted_2 = {
  class: "left common-shadow"
};
var _hoisted_3 = {
  class: "info"
};
var _hoisted_4 = {
  class: "text-center",
  style: {
    "margin": "20px 0"
  }
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  style: {
    "font-size": "28px",
    "font-weight": "600"
  }
};
var _hoisted_7 = {
  style: {
    "margin-top": "35px"
  }
};
var _hoisted_8 = {
  class: "item"
};
var _hoisted_9 = {
  style: {
    "float": "right"
  }
};
var _hoisted_10 = {
  class: "item"
};
var _hoisted_11 = {
  style: {
    "float": "right"
  }
};
var _hoisted_12 = {
  class: "item"
};
var _hoisted_13 = {
  style: {
    "float": "right"
  }
};
var _hoisted_14 = {
  class: "item"
};
var _hoisted_15 = {
  style: {
    "float": "right"
  }
};
var _hoisted_16 = {
  class: "right common-shadow"
};
var _hoisted_17 = {
  style: {
    "display": "flex"
  }
};
var _hoisted_18 = {
  class: "img"
};
var _hoisted_19 = {
  style: {
    "text-align": "center",
    "margin-bottom": "8px"
  }
};
var _hoisted_20 = ["src"];
import { changePasswordUrl, updateProfile, updateProfileUrl } from '@/api/system/user';
import { createFormItem } from '@/component-create/utils/create-form-item';
import { EditForm } from '@/component-create/EditForm';
import { FORM_ITEM } from '@/components/form/enums';
import useStore from '@/store';
import { toast } from '@/utils/message';

import { ref, onMounted, h } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Profile',
  setup: function setup(__props) {
    var store = useStore();
    var user = ref(store.user.profile || {});
    var activeTab = ref('profile');
    var baseInfoRef = ref();
    var accountRef = ref();
    var baseForm = null;
    var accountForm = null;
    onMounted(function () {
      createBaseInfoForm();
      createAccountForm();
    });
    function handleAvatar(file) {
      if (!file.size) {
        return;
      }
      var limit = file.size / 1024 < 1024;
      if (!limit) {
        toast.warn('上传头像图片大小不能超过 1024KB!');
        return;
      }
      var reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = function () {
        user.value.avatarCode = reader.result;
      };
    }
    function createBaseInfoForm() {
      var items = [[createFormItem('用户名', 'username', FORM_ITEM.INPUT, {
        placeholder: '请输入用户名',
        disabled: true
      })], [createFormItem('昵称', 'nickname', FORM_ITEM.INPUT, {
        placeholder: '请输入昵称'
      })], [createFormItem('性别', 'gender', FORM_ITEM.SELECT, {
        placeholder: '请选择性别',
        loader: 'USER_GENDER'
      })], [createFormItem('电子邮箱', 'email', FORM_ITEM.INPUT, {
        placeholder: '请输入电子邮箱',
        maxlength: "50"
      })], [createFormItem('手机号码', 'phoneNumber', FORM_ITEM.INPUT, {
        placeholder: '请输入手机号码',
        maxlength: "11"
      })], [createFormItem('', '', function () {
        return h(_createVNode2(_resolveComponent2("el-button"), {
          "type": "primary",
          "onClick": baseFormSave
        }, {
          default: function _default() {
            return [_createTextVNode2("\u4FDD\u5B58")];
          }
        }));
      })]];
      baseForm = new EditForm(baseInfoRef.value, items, {
        labelPosition: 'top'
      }, updateProfileUrl, '', false, 'put');
      baseForm.setFormData({
        username: user.value.username,
        nickname: user.value.nickname,
        gender: user.value.gender,
        email: user.value.email,
        phoneNumber: user.value.phoneNumber
      });
    }
    function createAccountForm() {
      var items = [[createFormItem('旧密码', 'oldPassword', FORM_ITEM.INPUT, {
        placeholder: '请输入旧密码'
      })], [createFormItem('新密码', 'newPassword', FORM_ITEM.INPUT, {
        placeholder: '请输入新密码'
      })], [createFormItem('重复密码', 'newPasswordAgain', FORM_ITEM.INPUT, {
        placeholder: '请输入重复密码'
      })], [createFormItem('', '', function () {
        return h(_createVNode2(_resolveComponent2("el-button"), {
          "type": "primary",
          "onClick": AccountFormSave
        }, {
          default: function _default() {
            return [_createTextVNode2("\u4FDD\u5B58")];
          }
        }));
      })]];
      var rules = {
        oldPassword: [{
          required: true,
          message: '请输入旧的密码',
          trigger: 'blur'
        }, {
          min: 6,
          max: 20,
          message: '不能少于6个字符',
          trigger: 'blur'
        }],
        newPassword: [{
          required: true,
          message: '请输入新的密码',
          trigger: 'blur'
        }, {
          min: 6,
          max: 20,
          message: '不能少于6个字符',
          trigger: 'blur'
        }],
        newPasswordAgain: [{
          required: true,
          message: '请再次输入新的密码',
          trigger: 'blur'
        }, {
          min: 6,
          max: 20,
          message: '不能少于6个字符',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            var _accountForm;
            var data = (_accountForm = accountForm) === null || _accountForm === void 0 ? void 0 : _accountForm.getFormDataNotValidate();
            if (value !== data.newPassword) {
              callback(new Error('密码不一致'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      };
      accountForm = new EditForm(accountRef.value, items, {
        labelPosition: 'top',
        rules: rules
      }, changePasswordUrl, '', false, 'put');
    }
    var baseFormSave = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!baseForm) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return baseForm.getFormData();
            case 3:
              data = _context.sent;
              updateProfile(_objectSpread(_objectSpread({}, data), {}, {
                avatarCode: user.value.avatarCode
              })).then(function () {
                toast.success('保存成功');
                store.user.updateMyProfile(_objectSpread(_objectSpread({}, data), {}, {
                  avatarCode: user.value.avatarCode
                }));
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function baseFormSave() {
        return _ref.apply(this, arguments);
      };
    }();
    var AccountFormSave = function AccountFormSave() {
      var _accountForm2;
      (_accountForm2 = accountForm) === null || _accountForm2 === void 0 || _accountForm2.save();
    };
    return function (_ctx, _cache) {
      var _component_el_avatar = _resolveComponent("el-avatar");
      var _component_IEpUser = _resolveComponent("IEpUser");
      var _component_el_divider = _resolveComponent("el-divider");
      var _component_IEpPhone = _resolveComponent("IEpPhone");
      var _component_IEpMessage = _resolveComponent("IEpMessage");
      var _component_IEpStar = _resolveComponent("IEpStar");
      var _component_el_tag = _resolveComponent("el-tag");
      var _component_IEpPlus = _resolveComponent("IEpPlus");
      var _component_el_upload = _resolveComponent("el-upload");
      var _component_el_tab_pane = _resolveComponent("el-tab-pane");
      var _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "header"
      }, "个人信息", -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_avatar, {
        size: 100,
        src: _unref(user).avatarCode
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("img", {
            src: require('@/assets/images/avatars/male.png')
          }, null, 8, _hoisted_5)];
        }),
        _: 1
      }, 8, ["src"]), _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(user).nickname), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_createVNode(_component_IEpUser, {
        style: {
          "margin-right": "6px"
        }
      }), _cache[1] || (_cache[1] = _createTextVNode("用户名"))]), _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(user).username), 1)]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, [_createVNode(_component_IEpPhone, {
        style: {
          "margin-right": "6px"
        }
      }), _cache[2] || (_cache[2] = _createTextVNode("手机号码"))]), _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(user).phoneNumber), 1)]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, [_createVNode(_component_IEpMessage, {
        style: {
          "margin-right": "6px"
        }
      }), _cache[3] || (_cache[3] = _createTextVNode("电子邮箱"))]), _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(user).email), 1)]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", null, [_createVNode(_component_IEpStar, {
        style: {
          "margin-right": "6px"
        }
      }), _cache[4] || (_cache[4] = _createTextVNode("角色"))]), _createElementVNode("span", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(user).roles, function (role) {
        return _openBlock(), _createBlock(_component_el_tag, {
          key: role.roleCode,
          style: {
            "margin-left": "6px"
          }
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(role.roleName), 1)];
          }),
          _: 2
        }, 1024);
      }), 128))])]), _createVNode(_component_el_divider)])])]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_tabs, {
        modelValue: _unref(activeTab),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(activeTab) ? activeTab.value = $event : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_tab_pane, {
            label: "基本信息",
            name: "profile"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
                style: {
                  "width": "213px"
                },
                ref_key: "baseInfoRef",
                ref: baseInfoRef
              }, null, 512), _createElementVNode("div", _hoisted_18, [_cache[6] || (_cache[6] = _createElementVNode("span", null, "头像", -1)), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_upload, {
                class: "avatar-uploader",
                accept: ".gif,.jpg,.jpeg,.png,.GIF,.JPG,.PNG",
                action: "#",
                "auto-upload": false,
                "show-file-list": false,
                "on-change": handleAvatar
              }, {
                default: _withCtx(function () {
                  return [_unref(user).avatarCode ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(user).avatarCode,
                    class: "avatar"
                  }, null, 8, _hoisted_20)) : (_openBlock(), _createBlock(_component_IEpPlus, {
                    key: 1
                  }))];
                }),
                _: 1
              })])])])];
            }),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "账号安全",
            name: "account"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", {
                style: {
                  "width": "213px"
                },
                ref_key: "accountRef",
                ref: accountRef
              }, null, 512)];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["modelValue"])])]);
    };
  }
});